import { Target, Zap, Sparkles, Flame } from 'lucide-react';

interface ScoreTableauProps {
  totalAttempts: number;
  correctMatches: number;
  accuracy: number;
  streak: number;
}

export const ScoreTableau: React.FC<ScoreTableauProps> = ({
  totalAttempts,
  correctMatches,
  accuracy,
  streak,
}) => {
  return (
    <div className="p-6 bg-gradient-to-r from-orange-50/80 to-pink-50/80 rounded-2xl border border-orange-100">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 text-orange-600 mb-2">
            <Target className="w-5 h-5" />
            <span className="font-medium">Accuracy</span>
          </div>
          <span className="text-2xl font-bold text-gray-900">
            {accuracy}%
          </span>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 text-orange-600 mb-2">
            <Zap className="w-5 h-5" />
            <span className="font-medium">Correct</span>
          </div>
          <span className="text-2xl font-bold text-gray-900">{correctMatches}</span>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 text-orange-600 mb-2">
            <Sparkles className="w-5 h-5" />
            <span className="font-medium">Attempts</span>
          </div>
          <span className="text-2xl font-bold text-gray-900">{totalAttempts}</span>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 text-orange-600 mb-2">
            <Flame className="w-5 h-5" />
            <span className="font-medium">Streak</span>
          </div>
          <span className="text-2xl font-bold text-gray-900">{streak}</span>
        </div>
      </div>
    </div>
  );
}; 